import React from 'react';
import { FadeIn } from './FadeIn';
import { Check } from 'lucide-react';
export function Pricing() {
  const plans = [{
    name: 'Trial Class',
    price: '₹200',
    period: 'per session',
    description: 'Perfect for experiencing our teaching style and studio environment.',
    features: ['1 Full 60-min session', 'Access to any batch', 'Yoga mat provided', 'Consultation with instructor'],
    buttonText: 'Book Trial',
    isPopular: false
  }, {
    name: 'Monthly Plan',
    price: '₹1,500',
    period: 'per month',
    description: 'Our most flexible option for consistent practitioners.',
    features: ['Unlimited classes', 'Access to morning & evening batches', 'Personalized posture correction', 'Diet & nutrition guidance', 'Weekend special sessions'],
    buttonText: 'Join Monthly',
    isPopular: true
  }, {
    name: 'Quarterly Plan',
    price: '₹4,000',
    period: 'per 3 months',
    description: 'Best value for dedicated students committed to their journey.',
    features: ['Everything in Monthly Plan', 'Save ₹500 compared to monthly', 'Priority batch booking', '1-on-1 progress tracking', 'Free guest pass (1/month)'],
    buttonText: 'Join Quarterly',
    isPopular: false
  }];
  return <section className="py-24 bg-yoga-warm relative" data-id="element-289">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-290">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-291">
          <FadeIn data-id="element-292">
            <span className="text-yoga-primary font-bold uppercase tracking-wider text-sm block mb-2" data-id="element-293">
              Membership Plans
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-yoga-dark mb-6" data-id="element-294">
              Invest in your wellbeing
            </h2>
            <p className="text-lg text-yoga-muted" data-id="element-295">
              Simple, transparent pricing with no hidden fees. Choose the plan
              that best fits your commitment level.
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto items-center" data-id="element-296">
          {plans.map((plan, index) => <FadeIn key={index} delay={index * 100} data-id="element-297">
              <div className={`relative bg-white rounded-3xl p-8 shadow-sm transition-all duration-300 ${plan.isPopular ? 'border-2 border-yoga-primary shadow-xl md:-translate-y-4' : 'border border-gray-100 hover:shadow-lg'}`} data-id="element-298">
                {plan.isPopular && <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-yoga-primary text-white px-4 py-1 rounded-full text-sm font-bold tracking-wide" data-id="element-299">
                    MOST POPULAR
                  </div>}

                <h3 className="text-2xl font-bold text-yoga-dark mb-2" data-id="element-300">
                  {plan.name}
                </h3>
                <p className="text-yoga-muted text-sm mb-6 h-10" data-id="element-301">
                  {plan.description}
                </p>

                <div className="mb-8" data-id="element-302">
                  <span className="text-4xl font-bold text-yoga-dark" data-id="element-303">
                    {plan.price}
                  </span>
                  <span className="text-yoga-muted" data-id="element-304">/{plan.period}</span>
                </div>

                <ul className="space-y-4 mb-8" data-id="element-305">
                  {plan.features.map((feature, fIdx) => <li key={fIdx} className="flex items-start gap-3" data-id="element-306">
                      <div className="mt-1 bg-yoga-lightest rounded-full p-0.5 shrink-0" data-id="element-307">
                        <Check className="w-4 h-4 text-yoga-primary" data-id="element-308" />
                      </div>
                      <span className="text-yoga-dark" data-id="element-309">{feature}</span>
                    </li>)}
                </ul>

                <a href="#contact" className={`block w-full text-center py-4 rounded-full font-bold transition-colors ${plan.isPopular ? 'bg-yoga-primary text-white hover:bg-yoga-light shadow-md' : 'bg-yoga-lightest text-yoga-primary hover:bg-yoga-primary hover:text-white'}`} data-id="element-310">
                  {plan.buttonText}
                </a>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}